import {useRouter} from "next/router";
import {useEffect, useState} from "react";

export const useCountryLang = () => {
  const router = useRouter();

  // Initialize with router query parameters if available
  const [countryLang, setCountryLang] = useState<string | null>(() => {
    if (router.query.country && router.query.lang && !(router.query.country == 'xx')) {
      return `${router.query.country.toString()}/${router.query.lang.toString()}`;
    }
    return null;
  });

  useEffect(() => {
    // If we already have a value from router, we only update on navigation changes
    if (router.isReady && router.query.country && router.query.lang && !(router.query.country == 'xx')) {
      const routerCountryLang = `${router.query.country.toString()}/${router.query.lang.toString()}`;

      // Only update if it's different from current value
      if (routerCountryLang !== countryLang) {
        setCountryLang(routerCountryLang);
      }
    }
  }, [router.isReady, router.query.country, router.query.lang, router]);

  return countryLang;
}